import { Auth0JanaUserAdmin } from "./types";

export const isJanaAdmin = (user: Auth0JanaUserAdmin): boolean =>
  Boolean(user?.isJANAEmployee);
